import { createContext, useContext } from 'react'
import type { AuthSession, AuthStatus, SsoUser } from './types'

export interface AuthContextValue {
  status: AuthStatus
  session: AuthSession | null
  user: SsoUser | null
  isAuthenticated: boolean
  authError: string | null
  hasPermission: (permission: string) => boolean
  completeSso: (assertion: string) => Promise<SsoUser>
  logout: () => void
  refreshSession: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used inside AuthProvider')
  }
  return context
}
